import { formatSport, formatDateTime, formatBetType } from '../utils/formatters';

interface Event {
  id: string;
  sport: string;
  homeTeam: string;
  awayTeam: string;
  commenceTime: string;
  isLive?: boolean;
  status?: string;
}

interface Polymarket {
  betType?: 'moneyline' | 'spread' | 'total' | 'player_points' | string | null;
  currentPrice?: number | null;
  matchingConfidence?: number;
}

interface EventHeaderProps {
  event: Event;
  polymarket: Polymarket | null;
}

/**
 * Event header component showing sport, teams, time, and live status
 */
export default function EventHeader({ event, polymarket }: EventHeaderProps) {
  return (
    <div className="card">
      <div className="flex items-center justify-between">
        <div>
          <div className="flex items-center gap-2 text-sm text-gray-400 uppercase tracking-wide">
            <span>{formatSport(event.sport)}</span>
            {polymarket?.betType && (
              <span className={`px-2 py-0.5 rounded text-xs font-medium ${
                polymarket.betType === 'moneyline' ? 'bg-blue-500/20 text-blue-400 border border-blue-500/30' :
                polymarket.betType === 'spread' ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30' :
                polymarket.betType === 'total' ? 'bg-green-500/20 text-green-400 border border-green-500/30' :
                polymarket.betType.startsWith('player_') ? 'bg-orange-500/20 text-orange-400 border border-orange-500/30' :
                'bg-gray-500/20 text-gray-400 border border-gray-500/30'
              }`}>
                {formatBetType(polymarket.betType)}
              </span>
            )}
          </div>
          <h1 className="text-2xl font-bold mt-1">
            {event.homeTeam} vs {event.awayTeam}
          </h1>
          <div className="text-gray-400 mt-2">
            {formatDateTime(event.commenceTime)}
          </div>
        </div>
        <div className="text-right">
          {event.isLive ? (
            <span className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/20 text-red-400 rounded-full text-sm font-bold animate-pulse border border-red-500/30">
              <span className="w-3 h-3 bg-red-500 rounded-full"></span>
              LIVE NOW
            </span>
          ) : (
            <span
              className={`px-3 py-1 rounded-full text-sm ${
                event.status === 'scheduled'
                  ? 'bg-green-500/20 text-green-400'
                  : event.status === 'completed'
                  ? 'bg-gray-500/20 text-gray-400'
                  : 'bg-yellow-500/20 text-yellow-400'
              }`}
            >
              {event.status}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
